/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WidgetMetricRepresentation } from './WidgetMetricRepresentation';
import {
    WidgetMetricRepresentationFromJSON,
    WidgetMetricRepresentationFromJSONTyped,
    WidgetMetricRepresentationToJSON,
    WidgetMetricRepresentationToJSONTyped,
} from './WidgetMetricRepresentation';

/**
 * 
 * @export
 * @interface WidgetAxisRepresentation
 */
export interface WidgetAxisRepresentation {
    /**
     * 
     * @type {string}
     * @memberof WidgetAxisRepresentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetAxisRepresentation
     */
    config: string;
    /**
     * 
     * @type {number}
     * @memberof WidgetAxisRepresentation
     */
    position: number;
    /**
     * may be empty for some configs, tables can define n metrics
     * @type {Array<WidgetMetricRepresentation>}
     * @memberof WidgetAxisRepresentation
     */
    metrics: Array<WidgetMetricRepresentation>;
}

/**
 * Check if a given object implements the WidgetAxisRepresentation interface.
 */
export function instanceOfWidgetAxisRepresentation(value: object): value is WidgetAxisRepresentation {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('metrics' in value) || value['metrics'] === undefined) return false;
    return true;
}

export function WidgetAxisRepresentationFromJSON(json: any): WidgetAxisRepresentation {
    return WidgetAxisRepresentationFromJSONTyped(json, false);
}

export function WidgetAxisRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetAxisRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'config': json['config'],
        'position': json['position'],
        'metrics': ((json['metrics'] as Array<any>).map(WidgetMetricRepresentationFromJSON)),
    };
}

export function WidgetAxisRepresentationToJSON(json: any): WidgetAxisRepresentation {
    return WidgetAxisRepresentationToJSONTyped(json, false);
}

export function WidgetAxisRepresentationToJSONTyped(value?: WidgetAxisRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'config': value['config'],
        'position': value['position'],
        'metrics': ((value['metrics'] as Array<any>).map(WidgetMetricRepresentationToJSON)),
    };
}

